export const COMMUNITY_GOOGLE_METRICS_PAGE_SIZE = 10;
